module.exports = __webpack_public_path__ + "img/ornato-maya-01.a667068a.svg";